'use strict';

/**
 * Init event on page
 */
function init() {
    $('#rxExpirationForm').on('submit', function (e) {
        e.preventDefault();
        var form = $(this);
        if (grecaptcha) {
            grecaptcha.ready(function() {
                grecaptcha.execute(window.app.preferences.reCaptchaSiteKey, { action: 'submit' }).then(function(token) {
                    var existingTokenInput = form.find('input[name="dwfrm_rxCheckExpiration_reCaptchaToken"]');
                    if (existingTokenInput.length > 0) {
                        existingTokenInput.val(token);
                    } else {
                        form.append("<input type='hidden' name='dwfrm_rxCheckExpiration_reCaptchaToken' value='" + token + "'/>");
                    }
                    var formData = new FormData(form[0]);
                    $.ajax({
                        url: form.attr('action'),
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: function (response) {
                            if (response.expirationLabel && response.expirationLabel.length > 0) {
                                $('#voucher-message-container').html(response.expirationLabel);
                            } else {
                                $('#voucher-message-container').html('');
                            }
                        },
                        error: function (xhr, status, error) {
                            $('#voucher-message-container').html('');
                        }
                    });
                });
            });
        }
    });
}

init();
